"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;

var _react = _interopRequireDefault(require("react"));

var _AppBar = _interopRequireDefault(require("@mui/material/AppBar"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _Toolbar = _interopRequireDefault(require("@mui/material/Toolbar"));

var _styles = require("@mui/material/styles");

var _reactI18next = require("react-i18next");

var Footer = function Footer(_ref) {
  var title = _ref.title;
  var theme = (0, _styles.useTheme)();

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    color: "primary",
    position: "fixed",
    sx: {
      top: 'auto',
      bottom: 0,
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
    sx: {
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, t(title))));
};

exports.Footer = Footer;